import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';

export const getAddressThunk = createAsyncThunk(
    `AddressSlicer/getAddressThunk`,
    async (clientId = undefined, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
        };

        const participantId = clientId || user.profile['custom:participant_id'];

        const { data } = await conciergeApiClient.get(`Participant/${participantId}/addresses`, { headers });

        return data;
    }
);

const initialState = {
    dataAddress: [],
    loadingAddress: false,
    errorAddress: false,
};

const AddressSlicer = createSlice({
    name: 'Address',
    initialState,
    reducers: {
        resetDataAddress: (state) => {
            state.dataAddress = [];
            state.loadingAddress = false;
            state.errorAddress = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getAddressThunk.pending, (state) => {
            state.dataAddress = [];
            state.loadingAddress = true;
            state.errorAddress = false;
        });
        builder.addCase(getAddressThunk.fulfilled, (state, action) => {
            state.dataAddress = action.payload;
            state.loadingAddress = false;
            state.errorAddress = false;
        });
        builder.addCase(getAddressThunk.rejected, (state) => {
            state.dataAddress = [];
            state.loadingAddress = false;
            state.errorAddress = true;
        });
    },
});

export const { resetDataAddress } = AddressSlicer.actions;
export default AddressSlicer.reducer;